export enum RequestInputMode {
  Create
  // Update,
  // Delete
}
